import { TriageDeskSummary, useTriageDesk } from './TriageDeskSummary';
import { useTriageController } from './useTriageController';
import { TriageQueueControls } from './TriageQueueControls';
import { TriageQueueTable } from './TriageQueueTable';
import { TriageVerificationDialogs } from './TriageVerificationDialogs';
import { TriageIntakeDialog } from './TriageIntakeDialog';
export { formatCapacitySummary, buildLeadSummary, buildTriageFilterParams } from './triageDeskShared';
export function LeadTriageDashboard() {
const controller = useTriageController();
const summary = useTriageDesk();
const ctx = { ...controller, submitMemberAssign: async (...args: Parameters<typeof controller.submitMemberAssign>) => { await controller.submitMemberAssign(...args); summary.reload(); }, submitVerify: async () => { await controller.submitVerify(); summary.reload(); } };
return <div className="p-4 md:p-6 max-w-screen-2xl mx-auto"><TriageQueueControls ctx={ctx} summary={summary} /><TriageQueueTable ctx={ctx} /><TriageVerificationDialogs ctx={ctx} /><TriageIntakeDialog ctx={ctx} /><TriageDeskSummary resource={summary} section="queues" onSelect={name => { ctx.setTab('assigned'); ctx.setSearch(name); }} /></div>;
}

export default LeadTriageDashboard;
